import { render, staticRenderFns } from "./CustomizeMetalAH.vue?vue&type=template&id=0c02f154&scoped=true"
import script from "./CustomizeMetalAH.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAH.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAH.vue?vue&type=style&index=0&id=0c02f154&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c02f154",
  null
  
)

export default component.exports